import React from 'react';

const withoutItems = [
	"You rely on word of mouth and hope for the best",
	"You pay upfront and pray the tailor delivers",
	"You can’t tell if a tailor is actually good",
	"You chase tailors for updates with no response",
	"Your clothes come out different from what you imagined",
];

const withItems = [
	"Find tailors you can trust — backed by real work and reviews",
	"Pay safely knowing your money is protected",
	"See exactly what you’re getting before it’s made",
	"Get updates without chasing or stressing",
	"Receive outfits that match what you actually wanted",
];

export default function ProblemSolution() {
  return (
		<section
			id="why-kaftora"
			style={{
				padding: "100px 24px",
				background: "var(--surface)",
				position: "relative",
				overflow: "hidden",
			}}
		>
			{/* Decorative line */}
			<div
				style={{
					position: "absolute",
					top: 0,
					left: 0,
					right: 0,
					height: "1px",
					background:
						"linear-gradient(90deg, transparent, rgba(240,165,0,0.4), transparent)",
				}}
			/>

			<div style={{maxWidth: "960px", margin: "0 auto"}}>
				<div style={{textAlign: "center", marginBottom: "60px"}}>
					{/* <p
						style={{
							fontSize: "0.75rem",
							letterSpacing: "0.18em",
							textTransform: "uppercase",
							color: "var(--gold)",
							fontWeight: "500",
							marginBottom: "14px",
						}}
					>
						Why Kaftora Exists
					</p> */}
					<h2
						style={{
							fontFamily: "var(--font-display)",
							fontSize: "clamp(2rem, 4.5vw, 3.2rem)",
							fontWeight: "600",
							color: "#fff",
						}}
					>
						Getting clothes made
						<br />
						<span
							style={{color: "var(--gold)", fontStyle: "italic"}}
						>
							shouldn’t be this hard.
						</span>
					</h2>
				</div>

				<div
					style={{
						display: "grid",
						gridTemplateColumns:
							"repeat(auto-fit, minmax(300px, 1fr))",
						gap: "24px",
						alignItems: "start",
					}}
				>
					{/* Without */}
					<div
						style={{
							background: "rgba(255,80,80,0.04)",
							border: "1px solid rgba(255,80,80,0.15)",
							borderRadius: "16px",
							padding: "32px",
						}}
					>
						<div
							style={{
								display: "flex",
								alignItems: "center",
								gap: "10px",
								marginBottom: "28px",
							}}
						>
							<div
								style={{
									width: "32px",
									height: "32px",
									borderRadius: "50%",
									background: "rgba(255,80,80,0.15)",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									fontSize: "1rem",
								}}
							>
								✗
							</div>
							<h3
								style={{
									fontFamily: "var(--font-sans)",
									fontWeight: "600",
									fontSize: "0.9rem",
									letterSpacing: "0.1em",
									textTransform: "uppercase",
									color: "rgba(255,100,100,0.9)",
								}}
							>
								Today
							</h3>
						</div>
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								gap: "14px",
							}}
						>
							{withoutItems.map((item, i) => (
								<div
									key={i}
									style={{
										display: "flex",
										gap: "12px",
										alignItems: "flex-start",
									}}
								>
									<span
										style={{
											color: "rgba(255,80,80,0.7)",
											fontSize: "1rem",
											flexShrink: 0,
											marginTop: "2px",
										}}
									>
										✗
									</span>
									<span
										style={{
											color: "var(--text-muted)",
											fontSize: "0.925rem",
											lineHeight: "1.55",
										}}
									>
										{item}
									</span>
								</div>
							))}
						</div>
					</div>

					{/* With */}
					<div
						style={{
							background: "rgba(240,165,0,0.04)",
							border: "1px solid rgba(240,165,0,0.2)",
							borderRadius: "16px",
							padding: "32px",
							position: "relative",
							overflow: "hidden",
						}}
					>
						<div
							style={{
								position: "absolute",
								top: 0,
								right: 0,
								width: "100px",
								height: "100px",
								background:
									"radial-gradient(circle, rgba(240,165,0,0.12) 0%, transparent 70%)",
							}}
						/>
						<div
							style={{
								display: "flex",
								alignItems: "center",
								gap: "10px",
								marginBottom: "28px",
							}}
						>
							<div
								style={{
									width: "32px",
									height: "32px",
									borderRadius: "50%",
									background: "rgba(240,165,0,0.15)",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									fontSize: "1rem",
								}}
							>
								✓
							</div>
							<h3
								style={{
									fontFamily: "var(--font-sans)",
									fontWeight: "600",
									fontSize: "0.9rem",
									letterSpacing: "0.1em",
									textTransform: "uppercase",
									color: "var(--gold)",
								}}
							>
								With Kaftora
							</h3>
						</div>
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								gap: "14px",
							}}
						>
							{withItems.map((item, i) => (
								<div
									key={i}
									style={{
										display: "flex",
										gap: "12px",
										alignItems: "flex-start",
									}}
								>
									<span
										style={{
											color: "var(--gold)",
											fontSize: "1rem",
											flexShrink: 0,
											marginTop: "2px",
										}}
									>
										✓
									</span>
									<span
										style={{
											color: "rgba(255,255,255,0.8)",
											fontSize: "0.925rem",
											lineHeight: "1.55",
										}}
									>
										{item}
									</span>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</section>
  );
}
